enum scheduledStatus {
  Scheduling = 1,
  Sent = 2,
}

export default scheduledStatus;
